import React from 'react';
import {useNavigate} from "react-router-dom"
const TaskList = ({ tasks }) => {
const navigate=useNavigate()
  if (!tasks || tasks.length === 0) {
    return <div className="text-gray-500 text-center py-4">No tasks available.</div>;
  }


  return (
    <div className="border   p-4 w-full grid grid-cols-4 gap-4 "> {/* Container */}
      {tasks?.map((task, index) => (
        <div
          key={task.id} // Use index as key if task doesn't have a unique ID (not ideal, but acceptable for display-only lists)
          className={`py-2 mx-4 rounded-sm max-w-xs shadow-lg px-2 card ${index < tasks.length - 1 ? 'border-b border-gray-200' : ''}`} // Add bottom border except for last item
        >

<button
onClick={()=>{
  sessionStorage.setItem("timestamp", new Date().toISOString())
  navigate(`/survey/${task.projectId}/${task?.surveyType?.id}/${task?.locationId}`)
}}
>
          <div className="flex items-start"> {/* Use flexbox for alignment */}
            {/* Optional: Add a checkbox or icon here */}
            {/* <input type="checkbox" className="mr-2" /> */}
            <div className="flex-grow"> {/* Allow title to expand */}
              <h3 className="text-lg font-medium text-gray-800">{task?.surveyType?.name}</h3> {/* Display title */}
              {/* {<p className="text-gray-600 text-sm mt-1">{task.description || "Project Description"}</p>} Display description if present */}
              {/* Add other task details here as needed (e.g., due date, assigned user, etc.) */}
               {<p className="text-gray-500 text-xs mt-1">Due: {task.date}</p> }
               {<p className="text-gray-500 text-xs mt-1">Location: {task.location?.name} </p> }
               {<p className="text-gray-500 text-xs mt-1">Address: {task.location?.address}, {task.location?.state} </p> }
             </div>
            {/* Optional: Add an action button or menu here */}
            {/* <button className="text-gray-400 hover:text-gray-600">...</button> */}
          </div>
          </button>
        </div>
      ))}
    </div>
  );
};

export default TaskList;